/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { APIErrorSchema } from "./APIErrorSchema.ts"
import { z } from "zod/v4"

export const denyFollowRequestPathParamsSchema = z.object({
  requestId: z.string(),
})

/**
 * @description Successfully denied a follow request
 */
export const denyFollowRequest200Schema = z.object({
  message: z.string(),
})

/**
 * @description The \"Authorization\" header does not contain a valid Bearer access token.
 */
export const denyFollowRequest401Schema = APIErrorSchema

/**
 * @description Not authorized to deny this request
 */
export const denyFollowRequest403Schema = APIErrorSchema

/**
 * @description Request not found
 */
export const denyFollowRequest404Schema = APIErrorSchema

export const denyFollowRequestMutationResponseSchema =
  denyFollowRequest200Schema
